import React from 'react';
import PropTypes from "prop-types";

const Title = ({ value }) => <h5 className='my-3'>{value}</h5>;

Title.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired
}

export default Title;
